module.exports = __webpack_public_path__ + "static/img/cer_item_icon.7c05c234.png";